import { setOptions, importLibrary as loadLibrary } from '@googlemaps/js-api-loader';

const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

// Configure once — subsequent importLibrary calls are cached
// English results so a Seoul address autofills as "Jung-gu, Seoul", not 중구
setOptions({
  key,
  version: 'beta',
  language: 'en'
});

// Without a key, fail fast (no request to Google) so forms fall back to manual address entry
export const importLibrary = (name) =>
  key ? loadLibrary(name) : Promise.reject(new Error('VITE_GOOGLE_MAPS_API_KEY is not set'));
